import React from "react";
import { AnimationAuxDiv, Box, Container } from "./styles";
import { FaCheck } from "react-icons/fa";
var Checkbox = function (_a) {
    var label = _a.label, checked = _a.checked, onClick = _a.onClick, labelStyles = _a.labelStyles, containerStyles = _a.containerStyles, disabled = _a.disabled, customColor = _a.customColor;
    return (React.createElement(Container, { style: containerStyles, onClick: function () { return onClick(!checked); }, disabled: disabled, customColor: customColor },
        React.createElement(Box, { customColor: customColor },
            React.createElement(AnimationAuxDiv, { checked: checked },
                React.createElement(FaCheck, null))),
        label && React.createElement("span", { style: labelStyles }, label)));
};
Checkbox.defaultProps = {
    checked: false,
    onClick: function () { },
    disabled: false,
    customColor: "#2ec9b7"
};
export default Checkbox;
//# sourceMappingURL=index.js.map